import React, { useMemo, useState, useRef } from "react";
import { useReactTable, getCoreRowModel } from "@tanstack/react-table";
import PaginateList from "./PaginateSelectList.view";
import { useQuery } from "@tanstack/react-query";
// import { withTranslation } from "react-i18next";
const IndeterminateCheckbox = ({ indeterminate, className = "", ...rest }) => {
  const ref = useRef(null);

  React.useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate]);

  return (
    <input
      type="checkbox"
      ref={ref}
      className={className + " cursor-pointer"}
      {...rest}
    />
  );
};

const PaginateSelectListContainer = ({
  columns,
  toList,
  hideColum,
  filters,
  resize = true,
  refresh,
  resetRefresh,
  onChangeSelect,
}) => {
  // const columnsDef = useMemo(() => columns, []);
  const index = columns.findIndex((col) => col.id === "select");
  if (index === -1) {
    columns.unshift({
      id: "select",
      header: ({ table }) => (
        <IndeterminateCheckbox
          {...{
            checked: table.getIsAllRowsSelected(),
            indeterminate: table.getIsSomeRowsSelected(),
            onChange: table.getToggleAllRowsSelectedHandler(),
          }}
        />
      ),
      cell: ({ row }) => (
        <div className="px-1">
          <IndeterminateCheckbox
            {...{
              checked: row.getIsSelected(),
              disabled: !row.getCanSelect(),
              indeterminate: row.getIsSomeSelected(),
              onChange: row.getToggleSelectedHandler(),
            }}
          />
        </div>
      ),
    });
  }

  const [rowSelection, setRowSelection] = useState({});
  const defaultData = useMemo(() => [], []);
  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const pagination = useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize]
  );

  const fetchData = async (pageIndex, pageSize) => {
    const filter = {
      page: pageIndex + 1,
      pageSize: pageSize || 10,
    };
    if (filters) {
      filter.filters = filters;
    }
    const result = await toList(filter);
    if (refresh) {
      resetRefresh();
    }
    return {
      rows: result?.docs || [],
      pageCount: result?.totalPages || 0,
      totalDocs: result?.totalDocs || 0,
    };
  };

  //TODO: force refresh
  const dataQuery = useQuery(
    {
      queryKey: [
        "data",
        {
          pageIndex,
          pageSize,
          filters,
          refresh,
        },
      ],
      queryFn: () => fetchData(pageIndex, pageSize),
      // queryKeyHashFn: (queryKey, dd) => refreshQuery(queryKey, dd),
      refetchOnWindowFocus: false,
    }
    // { keepPreviousData: true }
  );

  const table = useReactTable({
    data: dataQuery.data?.rows ?? defaultData,
    columns: columns, //columnsDef,
    enableColumnResizing: resize,
    columnResizeMode: "onChange",
    pageCount: dataQuery.data?.pageCount ?? -1,
    enableRowSelection: true,
    autoResetSelectedRows: false,
    getRowId: (row) => row.uuid,
    state: {
      columnVisibility: hideColum || {},
      pagination,
      totalDocs: dataQuery.data?.totalDocs ?? 0,
      rowSelection,
    },
    onPaginationChange: setPagination,
    getCoreRowModel: getCoreRowModel(),
    onRowSelectionChange: (eventData) => {
      if (onChangeSelect) {
        onChangeSelect(eventData);
      }
      setRowSelection(eventData);
    },
    manualPagination: true,
    // debugTable: true,
  });

  return <>{dataQuery.data ? <PaginateList table={table} /> : ""}</>;
  // return <PaginateList table={table} />;
};

export default PaginateSelectListContainer;
